import { ReactNode } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AccountSidebar } from "./AccountSidebar";
import { AccountSectionNav } from "./AccountSectionNav";
import { useIsMobile } from "@/hooks/use-mobile";

interface AccountLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  /** Page-level actions, right of the title (under it on phones). */
  actions?: ReactNode;
}

export function AccountLayout({ children, title, subtitle, actions }: AccountLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <div className="page-shell flex flex-col">
      <Header />

      <main className="flex-1">
        <div className="container pt-4 pb-12">
          {/* Phones: visible section switcher instead of a second ☰ (logout is in the header
              menu). The title is plain on every width, like every other page. */}
          {isMobile && <AccountSectionNav />}

          <div className="flex gap-6">
            {!isMobile && <AccountSidebar />}
            <div className="flex-1 min-w-0">
              <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h1 className="page-title">{title}</h1>
                  {subtitle && <p className="page-subtitle">{subtitle}</p>}
                </div>
                {actions}
              </div>
              {children}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
